import React, {useEffect, useRef, useState}         from "react";
import {Toast}                                      from "primereact/toast";
import {DataTable}                                  from "primereact/datatable";
import {CabecalhoTabela, FundoSistema, TelaSistema} from "../../assets/style";
import Menu                                         from "../../components/menu";
import {IdClienteLogado, UsuarioMaster}             from "../../services/auth";
import useMobile                                    from "../../hooks/useMobile";
import {Column}                                     from "primereact/column";
import {FilterMatchMode}                            from "primereact/api";
import api, {URLAPI}                                from "../../services/api";
import debug                                        from "../../utils/debug";
import {InputText}                                  from "primereact/inputtext";
import {Button}                                     from "primereact/button";
import {confirmDialog}                              from "primereact/confirmdialog";

const Participante = () => {
    const {isMobile} = useMobile();
    const aviso = useRef(null);
    const endpointAPI = 'cadastro/participante';
    const [exibeMenu, setExibeMenu] = useState(true);
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState(null);
    const [lista, setLista] = useState([]);
    const [qtdeItens, setQtdeItens] = useState(0);
    const [pesquisaGeral, setPesquisaGeral] = useState(null);
    const [valorGlobalFiltro, setValorGlobalFiltro] = useState('');
    const [filtro, setFiltro] = useState({global: {value: null, matchMode: FilterMatchMode.CONTAINS}});

    useEffect(() => {
        carregarItens();
    }, []);

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
            carregarItens();
        }).catch((erro) => {
            debug(erro);
            aviso.current.show({
                                   severity: 'error',
                                   summary : 'Erro',
                                   detail  : (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado',
                                   life    : 3000
                               });
        });
    };

    const carregarItens = async () => {
        setLoading(true);
        await new api().requisitar('get', `${endpointAPI}/lista`).then((resposta) => {
            setLista(resposta);
            setQtdeItens(resposta?.length ?? 0);
            setLoading(false);
        }).catch((erro) => {
            debug(erro);
        });
    };

    const aoMudarFiltroGlobal = (e) => {
        const value = e.target.value;
        let _filtro = {...filtro};
        _filtro['global'].value = value;

        setFiltro(_filtro);
        setValorGlobalFiltro(value);
    }

    const aoExcluirItem = (id) => {
        confirmDialog({
                          message    : `Confirma exclusão do Participante?`,
                          header     : 'Atenção',
                          icon       : 'pi pi-exclamation-triangle',
                          acceptLabel: 'Sim',
                          rejectLabel: 'Não',
                          accept     : () => {
                              excluir(id);
                          },
                      });
    };

    const btnExcluir = (item) => {
        return (
            <Button icon={"pi pi-trash"} severity="danger" onClick={(e) => aoExcluirItem(item.idparticipante)}/>
        );
    }

    const cabecalhoTabela = (<React.Fragment>
        <CabecalhoTabela className='hidden md:flex'>
            <span className="m-0 text-lg">Participantes cadastrados</span>
            <span>
                <a href={`${URLAPI}/cadastro/evento/participantes-geral/${UsuarioMaster() ? 0 : IdClienteLogado()}`} title={"Download da lista de participantes XLS"} target={"_blank"} className={"mr-1"}>
                    <Button icon={"pi pi-file-excel"} severity="info" label="Lista em Excel"/>
                </a>
                <a href={`${URLAPI}/cadastro/evento/participantespdf-geral/${UsuarioMaster() ? 0 : IdClienteLogado()}`} title={"Download da lista de participantes PDF"} target={"_blank"} className={"mr-1"}>
                    <Button icon={"pi pi-file-pdf"} severity="info" label="Lista em PDF"/>
                </a>
            </span>
            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
            </span>
        </CabecalhoTabela>
        <div className='block md:hidden'>
            <div className='grid'>
                <div className="col-12">Participantes cadastrados</div>
                <div className="col-12 p-input-icon-left">
                    <i className="pi pi-search"/>
                    <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui" className="w-full"/>
                </div>
                <div className="col-12">
                    <a href={`${URLAPI}/cadastro/evento/participantes-geral/${UsuarioMaster() ? 0 : IdClienteLogado()}`} title={"Download da lista de participantes XLS"} target={"_blank"} className={"mr-1"}>
                        <Button icon={"pi pi-file-excel"} severity="info" label="Lista de participantes em Excel" className="w-full"/>
                    </a>
                </div>
                <div className="col-12">
                    <a href={`${URLAPI}/cadastro/evento/participantespdf-geral/${UsuarioMaster() ? 0 : IdClienteLogado()}`} title={"Download da lista de participantes PDF"} target={"_blank"} className={"mr-1"}>
                        <Button icon={"pi pi-file-pdf"} severity="info" label="Lista de participantes em PDF" className="w-full"/>
                    </a>
                </div>
            </div>
        </div>
    </React.Fragment>);

    return (
        <FundoSistema>
            <Menu/>
            <Toast ref={aviso}></Toast>
            <TelaSistema title="Participantes">
                <DataTable removableSort stripedRows
                           value={lista} responsiveLayout='stack' globalFilterFields={['nome']} selectionMode='single'
                           selection={item} onSelectionChange={(e) => setItem(e.value)} loading={loading}
                           globalFilter={pesquisaGeral} filters={filtro} header={cabecalhoTabela}
                           emptyMessage='Nenhum participante cadastrado'>
                    {UsuarioMaster() &&
                     <Column field={'cliente'} header={'Cliente'} sortable/>
                    }
                    <Column field={'nome'} header={'Participante'} sortable/>
                    <Column field={'email'} header={'E-mail'} sortable/>
                    <Column field={'especialidade'} header={'Especialidade'} sortable/>
                    <Column field={'crm'} header={'CRM/CRF'} sortable/>
                    <Column field={'titulo'} header={'Evento'} sortable/>
                    <Column field={'registro'} header={'Registro'} sortable/>
                    <Column field={'id'} header={''} body={btnExcluir}/>
                </DataTable>
            </TelaSistema>
        </FundoSistema>
    );
}

export default Participante;